import { createSlice } from '@reduxjs/toolkit'

export interface ClientIDState {
    value: string
}

const initialState: ClientIDState = {
    value: "",
}

export const clientIDSlice = createSlice({
    name: 'clientID',
    initialState,
    reducers: {
        addClientID: (state, action) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            state.value = action.payload;
            sessionStorage.setItem("clientID", action.payload);
        },
        removeClientID: (state) => {
            state.value = "";
            sessionStorage.setItem("clientID", "");
        }
    }
})

// Action creators are generated for each case reducer function
export const { addClientID, removeClientID } = clientIDSlice.actions

export default clientIDSlice.reducer


